import React, {Component} from 'react';
import { Form, Icon, Input, Button, Modal, Row, Col, Spin, Progress } from 'antd';
import { ROUTES } from 'utils/utils';
import { FORM, getDefaultValue } from 'utils/formUtils';
import LoginForm from 'components/forms/login/LoginForm';
import Login from 'components/login/Login';
import ForgotForm from 'components/forms/login/ForgotForm';
import Reset from 'containers/Reset';
import ChangeForm from 'components/forms/login/ChangeForm';
import { APP } from 'actions/appActions';
import { SESSION } from 'actions/sessionActions';
import { REST, AFSP } from 'utils/reqUtils';

export default class AfspLogin extends Component {
    styleProps = {
        row: {
            type: 'flex',
            justify: 'space-around',
            align: 'middle',
            style: {
                textAlign: 'center',
                overflow: 'auto',
                height: '110px'
            }
        },
        col: {
            span: 24,
            style: {
                display: 'table',
                height: '100%',
                width: '100%'
            }
        },
        span: {
            style: {
                display: 'table-cell',
                verticalAlign: 'middle'
            }
        },
        containerDiv: {
            style: {
                textAlign: 'center'
            }
        },
        textDiv: {
            style: {
                fontSize: 14,
                fontWeight: 'bold'
            }
        },
        indicatorDiv: {
            style: {
                marginTop: '10px'
            }
        }
    }

    constructor(props) {
        super(props);
        this.loginStyle = this.loginStyle.bind(this);
        this.getButton = this.getButton.bind(this);
        this.getView = this.getView.bind(this);
        this.getFooter = this.getFooter.bind(this);
    }

    isDisabled = () => this.props.captcha.status === 'valid' ? false : true;

    loginStyle(type) {
        switch(type) {
            case 'lrh':
                return { width: '170px', height: '22px' };
            default:
                return { width: '170px' };
        }
    }

    getButton(type) {
        switch(type) {
            case 'change':
                // If all the required form fields are valid then return a button that is not
                // disabled, else return it disabled.
                const { changeEmail } = this.props.state;
                for (var p in changeEmail)
                    if (changeEmail[p].form.required)
                        if (!changeEmail[p].valid)
                            return (
                                <Button type='primary' disabled='disabled'>
                                    {'Change Email'}
                                </Button>
                            );

                return (
                    <Button
                        type='primary'
                        disabled={this.isDisabled()}
                        onClick={() => services.doRequest(TYPE.PASSWORD_RESET_REQUEST, state.changeEmail)}
                    >
                        {'Change Email'}
                    </Button>
                );
        }
    }

    getView = (reqDisplay, modalProps, injectedView) => (
        <Modal {...modalProps}>
            <Row {...this.styleProps.row}>
                <Col {...this.styleProps.col}>
                    <span {...this.styleProps.span}>
                        {injectedView}
                    </span>
                </Col>
            </Row>
        </Modal>
    )

    getFooter(type, status) {
        const
        { state, controls, services } = this.props,
        { handleDisplay, changeModal } = controls,
        { STATUS } = REST,
        { TYPE } = AFSP;

        switch(type) {
            case 'login':
                switch(status) {
                    case STATUS.PENDING: return (
                        <div>
                            <Button type='default' disabled='disabled'>
                                {'Cancel'}
                            </Button>
                            <Button type='primary' disabled='disabled'>
                                {'Log In'}
                            </Button>
                        </div>
                    );

                    case STATUS.SUCCESS:
                        setTimeout(handleDisplay, 2500);
                        return null;

                    case STATUS.FAILURE: return (
                        <div>
                            <Button
                                size='small'
                                type='default'
                                icon='check'
                                style={{ borderRadius: '20px', width: '110px' }}
                                onClick={() => handleDisplay()}
                            >
                                {'Ok'}
                            </Button>
                        </div>
                    );

                    default: return (
                        <div>
                            <Button
                                type='primary'
                                icon='login'
                                size='small'
                                style={{ borderRadius: '20px', width: '110px' }}
                                onClick={() => services.doRequest(TYPE.LOGIN, state.login)}
                            >
                                {'Log In'}
                            </Button>
                        </div>
                    );
                }

            case 'forgot':
                switch(status) {
                    case STATUS.PENDING: return (
                        <div>
                            <Button disabled size='small' type='default' icon='left' style={{ width: '90px', marginRight: '107px'}}>
                                {'Back'}
                            </Button>
                            <Button disabled size='small' type='default' style={{ width: '90px' }}>
                                {'Cancel'}
                            </Button>
                            <Button disabled loading size='small' type='primary' style={{ width: '185px' }}>
                                {'Request Password Reset'}
                            </Button>
                        </div>
                    );

                    case STATUS.SUCCESS: return (
                        <div>
                            <Button
                                size='small'
                                type='default'
                                icon='check'
                                style={{ borderRadius: '20px', width: '110px' }}
                                onClick={() => handleDisplay()}
                            >
                                {'Ok'}
                            </Button>
                        </div>
                    );

                    case STATUS.FAILURE: return (
                        <div>
                            <Button
                                size='small'
                                type='default'
                                icon='check'
                                style={{ borderRadius: '20px', width: '110px' }}
                                onClick={() => handleDisplay()}
                            >
                                {'Ok'}
                            </Button>
                        </div>
                    );

                    default: return (
                        <div>
                            <Button
                                size='small'
                                type='default'
                                icon='left'
                                onClick={() => changeModal('login')}
                                style={{ width: '90px', marginRight: '107px'}}
                            >
                                {'Back'}
                            </Button>
                            <Button
                                size='small'
                                type='default'
                                onClick={() => handleDisplay()}
                                style={{ width: '90px' }}
                            >
                                {'Cancel'}
                            </Button>
                            <Button
                                size='small'
                                type='primary'
                                style={{ width: '185px' }}
                                onClick={() => services.doRequest(TYPE.PASSWORD_RESET_REQUEST, state.login)}
                                disabled={this.isDisabled()}
                            >
                                {'Request Password Reset'}
                            </Button>
                        </div>
                    );
                }
        }
    }

    showView(type) {
        const
        { sref, state, controls, modal, win, services } = this.props,
        { handleDisplay, changeModal, resetDisplay, showLoginFailure } = controls,
        { incrementFailedAttempts } = this,
        { login, request } = state,
        { visible } = modal,
        { TYPE } = AFSP,
        { STATUS } = REST;

        let
        reqState = request.home[type],
        reqDisplay = 'login',
        modalProps = {
            visible: visible,
            closable: true,
            onCancel: () => handleDisplay(),
            afterClose: () => resetDisplay(sref)
        },
        formProps = {
            notices: {
                error: false
            },
            controls: controls,
            service: (type, data) => services.setData(type, data),
            services: this.props.services
        };

        switch(type) {
            case 'login': return (
                <Login
                    controls={controls}
                    services={services}
                    request={reqState}
                    showPasswordUpdate={state.showPasswordUpdate}
                    modalProps={{...modalProps,
                        title: 'Log In',
                        footer: this.getFooter('login', reqState.status)
                    }}
                    formProps={{...formProps,
                        sref: 'login',
                        state: login.login
                    }}
                    reset={() => {
                        controls.handleDisplay();
                        services.setData(APP.REQUEST.HOME.LOGIN.RESET);
                        services.setData('login', {...state.login.login,
                            password: {...state.login.login.password,
                                valid: false,
                                value: getDefaultValue(FORM.TYPES.PASSWORD)
                            }
                        });
                    }}
                />
            );

            case 'forgot':
                reqDisplay = 'forgot';
                modalProps = {...modalProps,
                    title: (
                        <div>
                            <div>{'Forgot Password:'}</div>
                            <div style={{ fontSize: '12px' }}>
                                <i>{'Please provide either your User ID or your Email address.'}</i>
                            </div>
                        </div>
                    ),
                    footer: this.getFooter('forgot', reqState.status)
                }
                formProps = {...formProps,
                    sref: 'forgotten',
                    captcha: this.props.captcha,
                    state: login.forgotten
                };

                switch(reqState.status) {
                    case STATUS.NONE: return (
                        <Reset
                            type='reset-password-request'
                            modalProps={modalProps}
                            changeModal={changeModal}
                            handleDisplay={handleDisplay}
                            resetPassword={() => services.doRequest(TYPE.PASSWORD_RESET_REQUEST, state.login)}
                        />
                    );

                    case STATUS.PENDING:
                        return this.getView(reqDisplay, modalProps,
                            <div>
                                <div {...this.styleProps.textDiv}>{'Requesting a password reset...'}</div>
                                <div style={{ fontStyle: 'italic' }}>
                                    {'Please wait...'}
                                </div>
                                <div {...this.styleProps.indicatorDiv}>
                                    <Spin indicator={<Icon type = 'loading' style = {{ fontSize: 40 }}/>}/>
                                </div>
                            </div>
                        );

                    case STATUS.SUCCESS:
                        return this.getView(reqDisplay, modalProps,
                            <div>
                                <div {...this.styleProps.textDiv}>{'Request SUCCESSFUL!'}</div>
                                <div style={{ fontStyle: 'italic' }}>
                                    {'Please check your email.'}
                                </div>
                                <div {...this.styleProps.indicatorDiv}>
                                    <Progress type='circle' width={45} percent={100}/>
                                </div>
                            </div>
                        );

                    case STATUS.FAILURE:
                        return this.getView(reqDisplay, modalProps,
                            <div>
                                <div {...this.styleProps.textDiv}>{'Request FAILED'}</div>
                                <div style={{ fontStyle: 'italic' }}>
                                    {'Unable to request a reset...'}
                                </div>
                                <div {...this.styleProps.indicatorDiv}>
                                    <Progress type='circle' width={45} percent={100} status='exception'/>
                                </div>
                            </div>
                        );
                }
        }
    }

    render() {
        const
        { styler, controls, modal, services, state } = this.props,
        { handleDisplay } = controls,
        { view } = modal,
        { TYPE } = AFSP;

        return ( //
            <div onKeyPress={e => { if(e.charCode === 13) services.doRequest(TYPE.LOGIN, state.login); }}>
                <Button
                    type='primary'
                    icon='login'
                    style={this.loginStyle(styler)}
                    onClick={() => handleDisplay()}
                >{'Log In'}</Button>
                {this.showView(view)}
            </div>
        );
    }
}
